<template>
    <div class="page-content" style="margin-top: 20px">
        <el-row  class="search-title common-table-top">
            <el-col :span="4" class="order-list-text" style="text-align: left;padding-left: 20px">
                <span>{{isDetail?'查看区域':'编辑区域'}}</span>
            </el-col>
        </el-row>

        <el-row class="box-content">
            <div style="display: flex;justify-content: center;align-items:center;min-height: 600px;" v-loading="isLoading">
                <el-form ref="form" :model="form" :rules="rules" label-width="110px" class="widthInfo">
                    <el-form-item label="编码：" prop="code">
                        <el-input v-model="form.code" :disabled="isDetail"></el-input>
                    </el-form-item>
                    <el-form-item label="名称：" prop="name">
                        <el-input v-model.trim="form.name" :disabled="isDetail"></el-input>
                    </el-form-item>
                    <el-form-item label="业务区域描述：" >
                        <el-input :disabled="isDetail" v-model.trim="form.description" type="textarea"
                                  :autosize="{ minRows: 1, maxRows: 4}" class="areaTextare"></el-input>
                    </el-form-item>
                    <el-form-item label="包含城市：" prop="areaList">
                        <div class="areaWidth" style="text-align: right;margin-bottom: 10px;" v-if="!isDetail">
                            <el-button @click="addRegion" style="background-color: #1890FF;color: #ffffff;border: 0;border-radius: 2px;">新建</el-button>
                        </div>
                        <div class="listRegion">
                            <el-table :data="listRegion" border size="mini" style="border-top: 1px solid #EBEEF5;margin-right: 0!important;margin-left: 0px!important;">
                                <template slot="empty">
                                    <div class="newTableEmpty">暂无数据，去<span @click="addRegion">新建</span></div>
                                </template>
                                <el-table-column min-width="100" align="center" label="省">
                                    <template slot-scope="scope">
                                        <!-- slot-scope="scope"-->
                                        <el-select :disabled="isDetail" v-model="scope.row.province.code" @change="((value)=>{changeProvince(value, scope.$index)})"
                                                   placeholder="请选择省">
                                            <el-option v-for="(item, index) in listChoose[scope.$index].provinceList" :key="index"
                                                       :label="item.label" :value="item.value"></el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column min-width="100" align="center" label="市">
                                    <template slot-scope="scope">
                                        <!-- slot-scope="scope"-->
                                        <el-select :disabled="isDetail" v-model="scope.row.city.code" @change="((value)=>{changeCity(value, scope.$index)})"
                                                   placeholder="请选择市">
                                            <el-option v-for="(item, index) in listChoose[scope.$index].cityList" :key="index" :label="item.label"
                                                       :value="item.value"></el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column min-width="100" align="center" label="区">
                                    <template slot-scope="scope">
                                        <!-- -->
                                        <el-select :disabled="isDetail" v-model="scope.row.area.code" @change="((value)=>{changeArea(value, scope.$index)})"
                                                   placeholder="请选择区">
                                            <el-option v-for="(item, index) in listChoose[scope.$index].areaList" :key="index" :label="item.label"
                                                       :value="item.value"></el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column v-if="!isDetail" class="aud-operatopn-div" align="center" label="操作" width="70">
                                    <template slot-scope="scope">
                                        <div class="op-link">
                                            <span class="op-link deleteColor" @click="deleteRegion(scope.$index)" style="font-size: 12px">删除</span>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-form-item>
                    <el-form-item label-width="0px" style="display: flex;justify-content: center;margin-top: 50px;">
                        <el-button v-if="!isDetail" class="second-page-btn" style="width: 80px;height: 40px;"
                                   type="primary" @click="edit('form')" :loading="isLoading">确定</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-row>
    </div>
</template>
<script>
import { getDepartment, getRoleList, editMember, getMemberDetail } from '@/api/customer.js'
import { addOrUpdate, businessAreaDetail } from '@/api/analyse.js'
import { getListTree } from '@/api/constrct.js'
import { regionDataPlus, regionData, CodeToText, TextToCode } from 'element-china-area-data'
export default {
  data() {
    const validateAreas = (rule, value, callback) => {
      if (this.listRegion.length === 0) {
        callback(new Error('请选择城市'))
      } else {
        this.listRegion.map(item=> {
          if (item.province.code === '') {
            callback(new Error('请选择城市'))
            return false
          }
        })
        callback()
      }
    }
    return {
      isLoading: false,
      form: {
        code: '',
        areaList: [],
        name: '',
        description: '',
        id: ''
      },
      isDetail: false,
      addressOptions: regionDataPlus,
      provinceList: regionDataPlus,
      cityList: [],
      areaList: [],
      listRegion: [{ province: { code: '', name: '' }, city: { code: '', name: '' }, area: { code: '', name: '' } }], // 选择省市区对应编码
      listChoose: [{ provinceList: regionDataPlus, cityList: [], areaList: [] }], // 选择列表
      recordPwd: '',
      rules: {
        areaList: [
          { required: true, validator: validateAreas, trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入区域名称', trigger: 'blur' }
        ],
        code: [
          {required: true, message: '请输入编码', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    // 改变省
    changeProvince (val, index) {
      let that = this
      that.listRegion[index].city = { code: '', name: '' }
      that.listRegion[index].area = { code: '', name: '' }
      if (val!=='') {
        this.listChoose[index].provinceList.forEach(function(item) {
          if (item.value === val) {
            that.listRegion[index].province.name = item.label
            that.listChoose[index].cityList = item.children
            that.listChoose[index].areaList = []
          }
        })
      } else {
        that.listChoose[index].cityList = []
        that.listChoose[index].areaList = []
      }
    },
    // 选择市
    changeCity (val, index) {
      let that = this
      that.listRegion[index].area = { code: '', name: '' }
      if (val!=='') {
        this.listChoose[index].cityList.forEach(function(item) {
          if (item.value === val) {
            that.listRegion[index].city.name = item.label
            that.listChoose[index].areaList = item.children
          }
        })
      } else {
        that.listRegion[index].city.name = ''
        that.listChoose[index].areaList = []
      }
    },
    // 选择区
    changeArea (val, index) {
      let that = this
      // 判断是否有重复
      let isCount = 0
      let address = ''
      for (var i = 0; i < that.listRegion.length; i++) {
        if (that.listRegion[i].area.code === val) {
          address = that.listRegion[i].province.name + that.listRegion[i].city.name + CodeToText[val]
          isCount++
        }
      }
      if (isCount > 1) {
        that.$message({
          type: 'error',
          message: address + '区域重复'
        })
        that.listRegion[index].area.code = ''
        return
      } else {
        this.listChoose[index].areaList.forEach(function (item) {
          if (item.value === val) {
            that.listRegion[index].area.name = item.label
          }
        })
      }
    },
    // 点击添加经营区域
    addRegion () {
      this.listChoose.push({ provinceList: regionDataPlus, cityList: [], areaList: [] })
      this.listRegion.push({ province: { code: '', name: '' }, city: { code: '', name: '' }, area: { code: '', name: '' } })
    },
    // 点击删除经营区域
    deleteRegion (index) {
      this.listRegion.splice(index, 1)
      this.listChoose.splice(index, 1)
    },
    edit() {
      this.$refs.form.validate((pass) => {
        if (pass) {
          let newarea = []
          this.listRegion.map(item=> {
            newarea.push({
              province: item.province.name,
              county: item.area.name,
              city: item.city.name
            })
          })
          this.form.areaList = newarea
          if (this.$route.query.type === 'add') {
            // 添加
            delete this.form.id
          }
          addOrUpdate(this.form).then((res) => {
            if (res.data.code === '200') {
              _g.toastMsg('success', res.data.message)
              router.push('/home/administrative/businessAreaList')
            } else {
              _g.toastMsg('error', res.data.message)
            }
          })
        }
      })
    },
    // 获取详情
    getDealerDetail (id) {
      let that = this
      this.isLoading = true
      businessAreaDetail({id: id}).then(res => {
        if (res.data.code === '200') {
          let data = res.data.result
          this.form = {
            areaList: data.areaList || [],
            name: data.name,
            description: data.description,
            id: data.id,
            code: data.code
          }
          let listRegionArr = []
          let listChooseArr = []
          if (data.areaList.length === 0) {
            listChooseArr = [{ provinceList: regionDataPlus, cityList: [], areaList: [] }]
            listRegionArr = []
          } else {
            data.areaList.forEach(function (item) {
              // if (item.province == '') {
              //   item.province = '全部'
              // }
              // if (item.city == '') {
              //   item.city = '全部'
              // }
              // if (item.county == '') {
              //   item.county = '全部'
              // }
              item.zoneCode = TextToCode[item.province].code
              if (item.city!=='') {
                item.zone1Code = TextToCode[item.province][item.city].code
              } else {
                item.zone1Code = ''
              }
              if (item.county!=='全部') {
                if (item.city!=='' && item.county!=='') {
                  item.zone2Code = TextToCode[item.province][item.city][item.county].code
                } else {
                  item.zone2Code = ''
                }
              }
              listRegionArr.push({
                province: { code: item.zoneCode, name: item.province },
                city: { code: item.zone1Code, name: item.city },
                area: { code: item.zone2Code, name: item.county }
              })
              let cityList = []
              let areaList = []
              regionDataPlus.forEach(function (it) {
                if (it.value == item.zoneCode) {
                  cityList = it.children
                  it.children.forEach(function (it1) {
                    if (it1.value === item.zone1Code) {
                      areaList = it1.children
                    }
                  })
                }
              })
              listChooseArr.push({
                provinceList: regionDataPlus,
                cityList: cityList || [],
                areaList: areaList || []
              })
            })
          }
          that.listChoose = listChooseArr
          if (listRegionArr.length == 0) {
            listRegionArr.push({
              province: { code: '', name: '全部' },
              city: { code: '', name: '' },
              area: { code: '', name: '' }
            })
          }
          that.listRegion = listRegionArr
          this.isLoading = false
        } else {
          this.isLoading = false
        }
      })
    }
  },
  created() {
    if (this.$route.query.type === 'edit' || this.$route.query.type === 'detail' ) {
      this.form.id = this.$route.query.id
      this.getDealerDetail(this.$route.query.id)
      this.isDetail = false
      if (this.$route.query.type === 'detail') {
        this.isDetail = true
      }
    }
  }
}
</script>
<style type="text/css" scoped>
    .areaWidth{
       width: 360px;
    }
    .widthInfo {
        width: 470px;
    }
    @media screen and (min-width:1260px) {
        .areaWidth{
            width: 560px;
        }
        .widthInfo {
            width: 670px;
        }
    }
    .listRegion {
        margin-bottom: 20px;
    }
</style>
